import ComputerIcon from "@svg/footer/computer";
import PalletIcon from "@svg/footer/pallet";
import CalculatorIcon from "@svg/footer/calculator";
import LanguageIcon from "@svg/footer/language";
import GraduatedIcon from "@svg/footer/graduated";
import InfoMenuIcon from "@svg/footer/info-menu";
import EachFooterCategory from "./EachFooterCategory";

const seeAllLinkMaker = (categoryId: number) => `/explore?publish_status=published&sort=most_sold&cost=not_free&category_id=${categoryId}&count=24`

const categories = [
  {
    title: "علوم کامپیوتر",
    moreItems: seeAllLinkMaker(333308),
    srcIcon: <ComputerIcon width={20} height={20} />,
    subCategories: [
      {
        title: "داده‌کاوی و یادگیری ماشین",
        link: "/how-to-learn/machine-learning-and-data-mining",
      },
      { title: "لینوکس", link: "/how-to-learn/linux" },
      { title: "پایتون (Python)", link: "/how-to-learn/python-programming" },
      { title: "هوش مصنوعی", link: "/how-to-learn/artificial-intelligence" },
      { title: "شبکه‌های کامپیوتری", link: "/how-to-learn/computer-networks" },
    ],
  },
  {
    title: "طراحی و گرافیک",
    moreItems: seeAllLinkMaker(3038),
    srcIcon: <PalletIcon width={20} height={20} />,
    subCategories: [
      { title: "نرم‌افزارهای Adobe", link: "/how-to-learn/adobe" },
      {
        title: "گرافیک کامپیوتری",
        link: "/how-to-learn/photoshop-computer-design-and-graphics",
      },
      { title: "اتوکد", link: "/how-to-learn/autocad" },
      {
        title: "کورل دراو",
        link: "/how-to-learn/corel",
      },
      {
        title: "انیمیشن‌سازی",
        link: "/how-to-learn/making-animation",
      },
    ],
  },
  {
    title: "اقتصاد و حسابداری",
    moreItems: seeAllLinkMaker(333209),
    srcIcon: <CalculatorIcon width={20} height={20} />,
    subCategories: [
      {
        title: "ارزهای دیجیتال",
        link: "/how-to-learn/digital-currency",
      },
      {
        title: "بورس و تحلیل تکنیکال",
        link: "/how-to-learn/stock-and-technical-analysis",
      },
      {
        title: "حسابداری",
        link: "/how-to-learn/accounting",
      },
      {
        title: "تحلیل تکنیکال",
        link: "/how-to-learn/technical-analysis",
      },
      {
        title: "علوم اقتصادی و مالی",
        link: "/how-to-learn/economics-and-finance",
      },
    ],
  },
  {
    title: "زبان خارجی",
    moreItems: seeAllLinkMaker(235656),
    srcIcon: <LanguageIcon width={20} height={20} />,
    subCategories: [
      { title: "زبان انگلیسی", link: "/how-to-learn/english-language" },
      {
        title: "آمادگی آزمون زبان خارجی",
        link: "/how-to-learn/language-exam-readiness",
      },
      { title: "زبان آلمانی", link: "/how-to-learn/german-language" },
      {
        title: "زبان فرانسه",
        link: "/how-to-learn/french-language",
      },
      {
        title: "زبان چینی",
        link: "/how-to-learn/chinese-language",
      },
    ],
  },
  {
    title: "دانشگاهی",
    moreItems: seeAllLinkMaker(333230),
    srcIcon: <GraduatedIcon width={20} height={20} />,
    subCategories: [
      {
        title: "مهندسی معماری",
        link: "/how-to-learn/architect-engineering",
      },
      { title: "مهندسی عمران", link: "/how-to-learn/civil-engineering" },
      { title: "مهندسی مکانیک", link: "/how-to-learn/mechanical-engineering" },

      {
        title: "مهندسی و علوم کامپیوتر",
        link: "/how-to-learn/computer-science-and-engineering",
      },
      { title: "مهندسی برق", link: "/how-to-learn/electrical-engineering" },
    ],
  },

  {
    title: "سایر دسته‌ها",
    moreItems: "/explore",
    srcIcon: <InfoMenuIcon width={20} height={20} />,
    subCategories: [
      { title: "آموزش‌های عمومی", link: "/how-to-learn/general" },
      {
        title: "ICDL",
        link: "/how-to-learn/icdl",
      },
      { title: "اکسل", link: "/how-to-learn/microsoft-excel" },
      {
        title: "مهارت‌های مطالعه",
        link: "/how-to-learn/study-skills-and-academic-success",
      },
      {
        title: "نوجوانان",
        link: "/how-to-learn/students-and-teenagers",
      },
    ],
  },
];

const FooterLinks: React.FC = () => {
  return (
    <div className="footer-links-parent">
      {categories.map((category, index) => (
        <EachFooterCategory category={category} key={index} />
      ))}
    </div>
  );
};

export default FooterLinks;
